module.exports = __webpack_public_path__ + "static/f300x375-71f1b01b17ec24887458b150edbbbba1.png";